export const DEFAULT_OPTIONS = {
  priority: [
    { value: "low", label: "Low" },
    { value: "medium", label: "Medium" },
    { value: "high", label: "High" },
    { value: "urgent", label: "Urgent" },
  ],
  manufacturer: ["Ardagh", "Ball Corp", "Canpack", "Canworks", "Craft Canning", "Fast Track", "Lagersmith", "Trivium"],
  design_type: ["New Design", "Revision"],
  conversion_type: ["Hard Conversion", "Soft Conversion"],
  print_type: ["Digital Printing", "Offset Printing"],
  decoration_method: ["Pressure Sensitive Label", "Shrink Sleeve"],
  beverage_type: [
    "Beer", "Carbonated Soft Drink", "Club Soda/Seltzer", "Coffee/Dairy", "Energy Drink",
    "FAB/Cider", "Juice", "Other", "Sparkling/Still Water", "Sports Drinks", "Tea", "Wine",
  ],
  beer_type: ["Caribbean Beer", "Craft Beer", "Domestic Beer", "European Beer", "Mexican Beer"],
  can_size: [
    "5.5oz", "6.8oz", "7.5oz Sleek", "8.4oz Sleek", "8.4oz Slim", "10oz Sleek",
    "12oz Standard", "12oz Sleek", "16oz Standard", "16oz Alumitek", "19.2oz", "24oz",
    "25.4oz", "32oz", "600ml Bottle", "Other",
  ],
  end_size: ["200", "202", "206", "209", "28mm", "38mm", "N/A"],
  end_type: ["B64", "CDL", "CDL+", "CDLW", "Crown", "ROPP", "XO-B64", "XO-CDL", "N/A"],
  pasteurization: ["Not Required", "Up to 140°F", "141–160°F", "161–180°F", "181°F and above"],
  symbol: ["None", "Kosher K", "Kosher CRC", "Kosher KOF", "Deposit", "NY Band"],
  specialty_ink: ["None", "Metallic", "Fluorescent", "Thermochromic", "Other"],
  overvarnish: ["Gloss", "Matte", "Satin", "Tactile", "Retort"],
  inside_varnish: ["BPANI", "Epoxy"],
  sample_refrigeration_required: ["No", "Yes"],
  syrup_sample: ["No", "Yes"],
  beverage_contains: [
    "Acids: Citric, Malic", "Alkaline water", "Artificial Sweeteners: Sucralose, Aspartame",
    "Coconut water", "Colorants: Natural, Artificial", "Concentrated Juice, Not From Concentrate Juice",
    "Dairy & Dairy Alternatives", "Erythritol or Stevia", "Fruit pieces / Pulp",
    "High Intensity Sweeteners", "Honey / Agave", "Hop Extract", "Juices", "Kombucha",
    "Mineral water", "Natural Preservatives", "Naturally occurring Sulfites",
    "Other Preservatives / Processing Aids", "Preservatives: Potassium Sorbate, Sodium Benzoate",
    "Protein", "Puree", "Sugar", "Vitamins",
  ],
};

export const toOption = (item) => typeof item === "string"
  ? { value: item, label: item }
  : { value: String(item?.value || ""), label: String(item?.label || item?.value || "") };

export const configuredOptions = (allOptions, key, currentValues = []) => {
  const configured = allOptions?.form_options?.[key];
  const fallback = DEFAULT_OPTIONS[key] || [];
  const source = Array.isArray(configured) && configured.length
    ? configured
      .filter((entry) => entry?.active !== false)
      .sort((a, b) => Number(a.sort_order || 0) - Number(b.sort_order || 0))
      .map(toOption)
    : fallback.map(toOption);

  const result = [...source];
  const currents = Array.isArray(currentValues) ? currentValues : [currentValues];
  currents.forEach((current) => {
    const value = String(current || "").trim();
    if (value && !result.some((entry) => entry.value === value)) {
      result.push({ value, label: `${value} (inactive)` });
    }
  });
  return result;
};

export const normalizeManufacturer = (name) => {
  const normalized = String(name || "").trim().toLowerCase().replace(/[^a-z0-9]/g, "");
  if (normalized.includes("ball")) return "ballcorp";
  if (normalized === "canpack") return "canpack";
  return normalized;
};

export const manufacturerType = (name) => {
  const key = normalizeManufacturer(name);
  if (key === "ballcorp") return "ball";
  if (key === "canpack") return "canpack";
  return "other";
};

export const buildManufacturerOptions = (allOptions, currentName) => {
  const configured = configuredOptions(allOptions, "manufacturer", currentName);
  return configured.map((entry) => {
    const key = normalizeManufacturer(entry.value);
    const match = (allOptions?.manufacturers || []).find((item) => normalizeManufacturer(item.name) === key);
    return {
      value: match?.id || `manual:${key}`,
      label: entry.label,
      sourceName: match?.name || entry.value,
    };
  });
};

export const mergeSortedNames = (names, requiredNames = []) => {
  const unique = new Map();
  [...(names || []), ...requiredNames].forEach((name) => {
    const cleaned = String(name || "").trim();
    if (cleaned) unique.set(cleaned.toLowerCase(), cleaned);
  });
  return [...unique.values()].sort((a, b) => a.localeCompare(b));
};